import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material'
import { updateCandidatesReScoring } from '@assembly/api/candidates'
import { useSnackbars } from '@assembly/hooks'
import { SnackbarType } from '@assembly/contexts'
import { getApiErrorMsg } from '@assembly/utils'

interface UpdateCandidatesReScoringDialogProps {
    open: boolean
    onClose: () => void
    candidateIds: string[]
    onSuccess: () => void
}

export default function UpdateCandidatesReScoringDialog({
    open,
    onClose,
    candidateIds,
    onSuccess,
}: UpdateCandidatesReScoringDialogProps) {
    const { addAlert } = useSnackbars()
    const [isLoading, setIsLoading] = React.useState(false)

    const handleConfirm = async () => {
        try {
            setIsLoading(true)
            await updateCandidatesReScoring(candidateIds, true)
            addAlert({
                message: 'Successfully updated candidates for rescoring',
                type: SnackbarType.Success,
            })
            onSuccess()
            onClose()
        } catch (error: any) {
            addAlert({
                message: getApiErrorMsg(error),
                type: SnackbarType.Error,
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>ReScore Candidates</DialogTitle>
            <DialogContent>
                <Typography>
                    This will setup all of these candidates to be rescored based on the scoring prompt associated with the Job.
                    Do you want to continue?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>No</Button>
                <Button onClick={handleConfirm} disabled={isLoading} variant="contained" color="primary">
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    )
} 